import { useQuery, useQueryClient } from '@tanstack/react-query';
import { callAPIAdmin } from '../../../utils/apiUtils';
import { apiUrls } from '../../../utils/apiUrls';


export const adminProfileKeys = {
    profile: ['admin-profile'],
};

const fetchAdminProfile = async () => {
    const response = await callAPIAdmin(apiUrls.adminProfile, {}, 'GET', {});
    if (response?.data?.success) {
        return response.data.data;
    }
    throw new Error(response?.data?.message || 'Failed to fetch admin profile');
};

export const useAdminProfile = () => {
    return useQuery({
        queryKey: adminProfileKeys.profile,
        queryFn: fetchAdminProfile,
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        retry: 1,
    });
};

export const useInvalidateAdminProfile = () => {
    const queryClient = useQueryClient();

    const invalidateProfile = () => {
        queryClient.invalidateQueries({ queryKey: adminProfileKeys.profile });
    };

    return { invalidateProfile };
};